import HistoryContentContainer from '@/containers/HistoryContentContainer/HistoryContentContainer';
import HistoryListContainer from '@/containers/HistoryListContainer/HistoryListContainer';
import { resetNoteHistory } from '@/actions/NoteHistoryAction';
import Icon from '@/components/Icon/Icon';
import timeago from '@/utils/timeago';
import formatDate from '@/utils/formatDate';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { Row, Col } from 'antd';
import { NOTE_HISTORY_NOT_FOUND } from '../../constants/variables';
import styles from './HistoryPage.scss';
// containers
// import TestI18N from '../../components/TestI18N/TestI18N';

@withRouter
@connect(
  state => ({
  }),
  dispatch => ({
    resetNoteHistory: () => dispatch(resetNoteHistory()),
  }),
)
export default class HistoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 'home',
      size: 'large',
    };
  }

  componentWillMount() {
    // 首次进来需要重置数据
    this.props.resetNoteHistory();
  }

  render() {
    const { match } = this.props;
    return (
      <Row className={styles['history-page']}>
        <HistoryListContainer/>
        <HistoryContentContainer/>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/HistoryPage/HistoryPage.js